module.exports = __webpack_public_path__ + "img/select_bank_bk.fcd28504.png";